"use client";

import { theme } from "@/config/theme";
import { SCContainerContent, SCButton } from "@/utils/styledComponents";
import { useTranslations } from "next-intl";
import styled from "styled-components";
import GalleryCarousel from "./Component-GalleryCarousel-Location";
import { EmblaOptionsType } from "embla-carousel";

const LocationGallery = () => {
    const t = useTranslations("LocationGallery");

    const imageList = [
        {
            src: "/media/images/locations/bedok.jpg",
            alt: "Kids swimming lessons at Bedok Swimming Complex"
        },
        {
            src: "/media/images/locations/bishan.jpg",
            alt: "Kids swimming lessons at Bishan Swimming Complex"
        },
        {
            src: "/media/images/locations/bukin-canbera.jpg",
            alt: "Kids swimming lessons at Bukit Canberra"
        },
        {
            src: "/media/images/locations/cck.jpg",
            alt: "Kids swimming lessons at Choa Chu Kang Swimming Complex"
        },
        {
            src: "/media/images/locations/clementi.jpg",
            alt: "Kids swimming lessons at Clementi Swimming Complex"
        },
        {
            src: "/media/images/locations/jurong.jpg",
            alt: "Kids swimming lessons at Jurong Swimming Complex"
        },
        {
            src: "/media/images/locations/pasir-ris.jpg",
            alt: "Kids swimming lessons at Pasir Ris Swimming Complex"
        },
        {
            src: "/media/images/locations/sengkang.jpg",
            alt: "Kids swimming lessons at Sengkang Swimming Complex"
        },
        {
            src: "/media/images/locations/woodland.jpg",
            alt: "Kids swimming lessons at Woodlands Swimming Complex"
        }
    ];

    const OPTIONS: EmblaOptionsType = { loop: true };
    const SLIDES = imageList;

    return (
        <SCLocationGallery>
            <SCLocationGalleryContent>
                {/* <div className="text-container">
                    <div className="text-largexlarge">{t("title-text")}</div>
                    <div className="text-medium">{t("description-text")}</div>
                </div> */}
                <GalleryCarousel slides={SLIDES} options={OPTIONS} />
                <div className="button-wrapper">
                    <SCViewAllLocations
                        onClick={() => window.open(t("location-page"))}
                    >
                        {t("view-all-locations")}
                    </SCViewAllLocations>
                </div>
            </SCLocationGalleryContent>
        </SCLocationGallery>
    );
};

export default LocationGallery;

const SCLocationGallery = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${theme["color-light-yellow"]};
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCLocationGalleryContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: column;
    height: 80%;

    .button-wrapper {
        display: flex;
        justify-content: start;
        margin-top: ${theme["spacing-l"]};
    }

    .text-container {
        margin-bottom: ${theme["spacing-l"]};

        .text-largexlarge {
            font-size: ${theme["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${theme["spacing-m"]};
        }

        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
        }
    }

    // .embla {
    //     overflow: hidden;
    // }
    // .embla__container {
    //     display: flex;
    // }
    // .embla__slide {
    //     flex: 0 0 100%;
    //     min-width: 0;
    // }
`;

const SCViewAllLocations = styled(SCButton)`
    background-color: ${theme["color-blue"]};
    color: ${theme["color-white"]};
    border: none;
`;
